// eslint-disable-next-line
import React from 'react'
import logoIcon from '../../assest/logo2.svg'
const Logo = () => {
  return (
    <div>
        <img src={logoIcon} alt="logo"  />
    </div>
  )
}

export default Logo